import { MemberParams } from '@interfaces/member-params.model';
import { MemberPreferredContactMethods } from '@interfaces/member-preferred-contact-methods.model';

export class MemberContactPreferencesParams {
  public preference_type = 'contact_methods';
  public dob: string;
  public member_number: string;
  public receive_mail: boolean;
  public receive_email: boolean;
  public receive_phone_calls: boolean;
  public receive_text_messages: boolean;

  constructor(prefs: MemberPreferredContactMethods, member: MemberParams) {
    this.dob = member.dob;
    this.member_number = member.member_number;
    this.receive_mail = prefs.receive_mail;
    this.receive_email = prefs.receive_email;
    this.receive_phone_calls = prefs.receive_phone_calls;
    this.receive_text_messages = prefs.receive_text_messages;
  }
}
